import { spacing } from '../functions';

export default {
  root: {
    padding: `0 ${spacing(2)}`,
  },
  progress: { width: '90%', borderRadius: '2px' },
};
